module.exports = __webpack_public_path__ + "static/img/invite-code.6b3f3bdd.png";